import { useFormik } from "formik";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import PostApi from "api/postApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import {
  COLOR_BAR_DETAIL_REVIEW_STATUS,
  LIST_OPTION_BAR_DETAIL_REVIEW_STATUS,
} from "helpers/constans";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import UploadImage from "components/Common/UploadImage";
import DropdownAsyncBartender from "components/Common/DropdownAsyncBartender";
import DropdownAsyncBars from "components/Common/DropdownAsyncBars";
import { getPostDetail, getWinks } from "store/post/thunk";

export default function CreateEditWink({
  onCloseEditWinkClick,
  item,
  loadTableData,
  setLinkImage,
  isDetail = false
}: any) {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedManager, setSelectedManager] = useState<any>(null);
  const [selectedBartender, setSelectedBartender] = useState<any>(null);
  const [selectedBarStore, setSelectedBarStore] = useState<any>(null);
  const [barIdForSearch, setBarIdForSearch] = useState<string>("");
  const [isFirstProgress, setIsFirstProgress] = useState<boolean>(true);
  
  const isEdit = item;

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => false);
      const data = {
        post: {
          contents: values?.contents,
          type: 5,
          bar_id: values?.bar_id,
          user_id: values?.user_id,
          is_active: values?.is_active,
        },
        files: values?.files,
      };

      const response: any = isEdit
        ? await PostApi?.updatePost(item?.id, data)
        : await PostApi?.createPost(data);

      if (response?.data) {
        //  dispatch(onGetPosts(query));
        loadTableData();
        setIsLoading((_prev) => false);
        onCloseEditWinkClick();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading(false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast(`Please re-check your data`);
      return error;
    }
  };

  const validationSchema = Yup.object({
    user_id: Yup.string().required(`${t("This field is required")}`),
    bar_id: Yup.string().required(`${t("This field is required")}`),
    title: Yup.string()
      .nullable()
      .max(5000, `${t("Title must be at most 5000 characters long")}`),
    contents: Yup.string()
      .required(`${t("This field is required")}`)
      .max(50000, `${t("Contents must be at most 50000 characters long")}`),
    // files: Yup.array()
    //   .min(1, `${t("This field is required")}`)
    //   .required(`${t("This field is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      contents: "",
      is_active: 1,
      bar_id: "",
      user_id: "",
      type: 5,
      files: [],
      bar_name: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const formatBarSelected = (data: any) => {
    if(!data?.id) return;

    return {
      value: String(data?.id),
      label: (
        <div className="d-flex align-list-center gap-2">
          <div>{`${data?.nickname}`}</div>
        </div>
      ),
      data: data,
    };
  };

  const formatUserSelected = (data: any) => {
    if(!data?.id) return;

    return {
      value: String(data?.id),
      label: (
        <div className="d-flex align-items-center gap-2">
          <div>
            {`${data?.nickname ? data?.nickname + " -" : ""} ${data?.email ?? ''}`}
          </div>
        </div>
      ),
      data: data,
    };
  };

  const handleCallWinkDetail = async (winkID: string) => {
      try {
        const resDetail: any = await getPostDetail(winkID);
        if (resDetail?.data) {
          handleSetValueForm(resDetail?.data);
        }
      } catch (error: any) {
        return error;
      }
    };

  const handleSetValueForm = (item: any) => {
    if(!item) return;

    if (item?.bar) {
      const formatBarOption = formatBarSelected(item?.bar);
      setSelectedBarStore(formatBarOption);
      formik.setFieldValue("bar_id", item?.bar?.id);
      formik.setFieldValue("bar_name", item?.bar?.title);
    }

    if (item?.user_profile) {
      const formatManagerOption = formatUserSelected(item?.user_profile);
      setSelectedManager(formatManagerOption);
      formik.setFieldValue("user_id", item?.user_profile?.id);
    }
    formik.setFieldValue("files", item?.files);
    formik.setFieldValue("title", item?.title);
    formik.setFieldValue("contents", item?.contents);
    formik.setFieldValue("is_active", item?.is_active);
  }

  useEffect(() => {
    if (item) {
      if(isDetail === true) {
        handleCallWinkDetail(item)
      } else {
        handleSetValueForm(item)
      }
    }
  }, [item]);

  const [typeUsers, setTypeUsers] = useState<string>("manager");

  const resetDataByTypeUser = (type: string) => {
    if (type === "manager") {
      setSelectedManager(null);
    } else {
      setSelectedBartender(null);
    }
    formik.setFieldValue("bar_id", "");
    formik.setFieldValue("bar_name", "");
  };

  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      setIsFirstProgress(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(formik.errors).length]);
  
  return (
    <Modal isOpen={true} centered={true} scrollable={false} size="lg">
      <ModalHeader toggle={isLoading ? () => {} : onCloseEditWinkClick}>
        {isEdit ? (isDetail ? t("Detail Wink") : t("Button Update Wink")) : t("Button Create Wink")}
      </ModalHeader>
      <ModalBody className="py-3 px-4">
        {
          !isDetail && (
            <div className="mb-4">
              <Progress
                value={
                  (!isFirstProgress || !!item)
                    ? 100 - (100 / 3) * Number(Object.keys(formik.errors).length)
                    : 0
                }
                color="primary"
                className="animated-progress progress-sm"
              />
            </div>
          )
        }
        <form onSubmit={formik.handleSubmit}>
          <div className="row g-3">
            <Col lg={12}>
              <div className="">
                <Label htmlFor="titleKoreaInput" className="form-label">
                  {t("Type")} <span className="text-danger"></span>
                </Label>

                <div className="d-flex justify-content-start align-items-center">
                  <div
                    className="d-flex justify-content-start align-items-center form-check me-3"
                    onClick={() => {
                      if(isDetail) return;

                      setTypeUsers("manager");
                      resetDataByTypeUser("bartender");
                    }}
                  >
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="gender"
                      value={"manager"}
                      checked={"manager" === typeUsers}
                      style={{ minWidth: "16px" }}
                      disabled={isDetail}
                      onChange={(event) => {
                        setTypeUsers(event?.target?.value);
                        resetDataByTypeUser("bartender");
                      }}
                    />
                    <label
                      className="form-check-label position-relative"
                      htmlFor={`manager`}
                    >
                      {t("Manager")}
                    </label>
                  </div>

                  <div
                    className="d-flex justify-content-start align-items-center form-check me-3"
                    onClick={() => {
                      if(isDetail) return;
                      
                      setTypeUsers("bartender");
                      resetDataByTypeUser("manager");
                    }}
                  >
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="bartender"
                      value={"bartender"}
                      checked={"bartender" === typeUsers}
                      style={{ minWidth: "16px" }}
                      disabled={isDetail}
                      onChange={(event) => {
                        setTypeUsers(event?.target?.value);
                        resetDataByTypeUser("manager");
                      }}
                    />
                    <label
                      className="form-check-label position-relative"
                      htmlFor={`bartender`}
                    >
                      {t("Bartender")}
                    </label>
                  </div>
                </div>
              </div>
            </Col>

            <Col xxl={12}>
              <label className="form-label">{t("Store List")}</label>

              <DropdownAsyncBars
                name="bar_id"
                onChangeSelect={(event: any) => {
                  // formik.setFieldValue("bar_id", event?.value)
                  setSelectedBarStore(event);
                  setBarIdForSearch(event?.value);

                  if (selectedBarStore?.value !== event?.value) {
                    setSelectedBartender(null);
                    setSelectedManager(null);
                    formik.setFieldValue("bar_id", "");
                    formik.setFieldValue("bar_name", "");
                  }
                }}
                isMulti={false}
                placeholder={`${t("Select Store")}...`}
                isShowIconCheck={false}
                isAllOption={false}
                listCheckedUsers={selectedBarStore}
                key={"bar-async"}
                isWink={true}
                partnerStatus="partnered"
                isDisabled={isDetail}
              />

              {formik.touched.bar_id && formik.errors.bar_id ? (
                <div className="text-danger mt-2">{formik.errors.bar_id}</div>
              ) : null}
            </Col>
            {typeUsers === "bartender" ? (
              <Col xxl={12}>
                <label className="form-label">
                  {t("Bartender")}
                  <span className="text-danger"> *</span>
                </label>

                <DropdownAsyncBartender
                  name="bartender"
                  onChangeSelect={(event: any) => {
                    formik.setFieldValue("user_id", event?.value);
                    setSelectedBartender(event);

                    if (event?.data?.bar) {
                      formik.setFieldValue("bar_id", event?.data?.bar?.id);
                      formik.setFieldValue("bar_name", event?.data?.bar?.title);
                    } else {
                      formik.setFieldValue("bar_id", "");
                      formik.setFieldValue("bar_name", "");
                    }
                  }}
                  isMulti={false}
                  placeholder={`${t("Select Bartender")}...`}
                  isShowIconCheck={false}
                  isAllOption={false}
                  paramsTypeUsers={2}
                  listCheckedUsers={selectedBartender}
                  isHideBatenderNull={true}
                  keywordSearch={barIdForSearch}
                  key={`list-${barIdForSearch || "all"}`}
                  isDisabled={isDetail}
                />

                {formik.touched.user_id && formik.errors.user_id ? (
                  <div className="text-danger mt-2">
                    {formik.errors.user_id}
                  </div>
                ) : null}
              </Col>
            ) : (
              <Col xxl={12}>
                <label className="form-label">
                  {t("Manager")}
                  <span className="text-danger"> *</span>
                </label>

                <DropdownAsyncUsers
                  name="manager"
                  onChangeSelect={(event: any) => {
                    formik.setFieldValue("user_id", event?.value);
                    setSelectedManager(event);

                    if (event?.data?.bar) {
                      formik.setFieldValue("bar_id", event?.data?.bar?.id);
                      formik.setFieldValue("bar_name", event?.data?.bar?.title);
                    }
                  }}
                  isMulti={false}
                  placeholder={`${t("Select Manager")}...`}
                  isShowIconCheck={false}
                  isAllOption={false}
                  paramsTypeUsers={3}
                  listCheckedUsers={selectedManager}
                  isHideBatenderNull={true}
                  keywordSearch={barIdForSearch}
                  key={`list-${barIdForSearch || "all"}`}
                  defaultParams={{ is_active: 1 }}
                  isDisabled={isDetail}
                />

                {formik.touched.user_id && formik.errors.user_id ? (
                  <div className="text-danger mt-2">
                    {formik.errors.user_id}
                  </div>
                ) : null}
              </Col>
            )}

            {formik?.values?.bar_name && (
              <Col lg={12}>
                <div className="mb-1">
                  <Label htmlFor="name-bar" className="form-label">
                    {t("Store Name")}
                  </Label>
                  <Input
                    name="bar_name"
                    type="text"
                    className="form-control"
                    placeholder={t("")}
                    value={formik?.values?.bar_name}
                    onChange={() => console.log("bar")}
                    disabled={true}
                  />
                  {formik.touched.bar_id && formik.errors.bar_id ? (
                    <div className="text-danger mt-2">
                      {formik.errors.bar_id}
                    </div>
                  ) : null}
                </div>
              </Col>
            )}

            <Col xxl={12}>
              <label className="form-label">
                {t("Content")}
                <span className="text-danger"> *</span>
              </label>
              <textarea
                className="form-control"
                name="contents"
                value={formik?.values?.contents}
                placeholder={`${t("Content")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue("contents", event?.target?.value || "")
                }
                style={{ height: 120 }}
                disabled={isDetail}
              />
              {formik.touched.contents && formik.errors.contents ? (
                <div className="text-danger mt-2">{formik.errors.contents}</div>
              ) : null}
            </Col>

            <Col xxl={12}>
              <label className="form-label">
                {t("Status")}
                <span className="text-danger"> *</span>
              </label>

              <DropdownStatusNew
                name="is_active"
                dataList={LIST_OPTION_BAR_DETAIL_REVIEW_STATUS || []}
                placeholder={`${t("Status")}...`}
                className="dropdown-status-rounded"
                classNamePrefix="name-prefix"
                initialValue={formik.values.is_active}
                onChangeSelect={(event: any) => {
                  formik.setFieldValue("is_active", event?.value);
                }}
                isHasOptionAll={false}
                colors={COLOR_BAR_DETAIL_REVIEW_STATUS}
                disabled={isDetail}
              />

              {formik.touched.is_active && formik.errors.is_active ? (
                <div className="text-danger mt-2">
                  {formik.errors.is_active}
                </div>
              ) : null}
            </Col>

            <Col xxl={12}>
              <label className="form-label">{t("Files")}</label>

              <UploadImage
                data={formik.getFieldProps("files")?.value}
                setLinkImage={setLinkImage}
                formik={formik}
                isDisabled={isDetail}
              />
            </Col>

            {
              !isDetail && (
                <div className="col-lg-12">
                  <div className="hstack gap-2 justify-content-end">
                    <button
                      className="btn btn-primary fs-14"
                      color="success"
                      type="submit"
                      disabled={isLoading}
                      style={{ width: "120px" }}
                    >
                      {isLoading ? (
                        <Spinner size="sm" className="me-2"></Spinner>
                      ) : (
                        <>{isEdit ? t("Button Update") : t("Button Create")}</>
                      )}
                    </button>
                    <button
                      className="btn btn-secondary fs-14"
                      color="light"
                      type="button"
                      onClick={onCloseEditWinkClick}
                      disabled={isLoading}
                      style={{ width: "100px" }}
                    >
                      {t("Button Close")}
                    </button>
                  </div>
                </div>
              )
            }
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
